const TINTS = {
  "ice-pink": "bg-ice-pink",
  "mint": "bg-mint",
  "sun-yellow-soft": "bg-sun-yellow-soft",
};

export default function ProductCard({ product, onOpen }) {
  const { id, name, price, tagline, image, tint, badges = [] } = product;
  const tintCls = TINTS[tint] || "bg-ice-pink";
  return (
    <button
      type="button"
      onClick={() => onOpen?.(product)}
      data-testid={`product-card-${id}`}
      className="group text-left relative bg-white rounded-[2rem] p-3 cushion overflow-hidden border border-[#F0E4E4] hover:-translate-y-2 transition-transform duration-300"
    >
      <div className={`relative ${tintCls} rounded-3xl overflow-hidden aspect-[4/5]`}>
        <img
          src={image} alt={name} loading="lazy"
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
        {badges[0] && (
          <span className="absolute top-3 left-3 sticker bg-choc text-cream text-[10px]" data-testid={`product-badge-${id}`}>
            {badges[0]}
          </span>
        )}
        <span className="absolute bottom-3 right-3 bg-cream text-choc font-bold text-sm px-3 py-1.5 rounded-full">
          {price}
        </span>
      </div>
      <div className="p-3 pt-4">
        <h3 className="font-serif text-xl leading-tight">{name}</h3>
        <p className="text-xs text-choc/70 mt-1">{tagline}</p>
      </div>
    </button>
  );
}

